const SessionTag = 'SEEL_CLAIM_PORTAL';

export const SessionStorageKey = {
  /** 是否自动登录过 */
  HasAutoLogin: `${SessionTag}_HAS_AUTO_LOGIN`,
};
